import React, { Component } from 'react'
import { CCOrderStatusCard } from 'app/ecommerce/common/components/order-status-card'
import type { CacOrder, DeviceCheck } from 'shared/types'
import styled from 'styled-components'
import type { EventMetadata } from 'shared/store/metadata'

type Props = {
    items: Array<any>,
    cardLayout: 'big' | 'full',
    sendMeta: EventMetadata => void,
    onClick: (order: CacOrder) => void,
    discard: (order: CacOrder) => void,
    cancelOrder: (
        id: string,
        token: string,
        deviceCheckPayload: DeviceCheck
    ) => void
}

class OrderStatusList extends Component<Props> {
    render() {
        const { items, onClick, discard, cancelOrder, sendMeta } = this.props
        return (
            <Container>
                {items.map((item, index) => (
                    <ItemContainer key={index}>
                        {!!item.pickUpType && (
                            <CCOrderStatusCard
                                order={item}
                                onClickDetails={() => onClick(item)}
                                sendMeta={sendMeta}
                                discard={discard}
                                cancelOrder={cancelOrder}
                                fromList={true}
                            />
                        )}
                    </ItemContainer>
                ))}
            </Container>
        )
    }
}

const Container = styled.div`
    margin-bottom: 20px;
    flex-wrap: wrap;
`
const ItemContainer = styled.div`
    flex: 1;
`
export { OrderStatusList }
